import { ReactNode } from 'react'

interface SnapshotStatCardProps {
  title: ReactNode
  value: ReactNode
  action?: ReactNode
}

export function SnapshotStatCard({ title, value, action }: SnapshotStatCardProps) {
  return (
    <div className="rounded-2xl p-6 border border-neutral-200 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-2">
        <span className="t-sm text-secondary">{title}</span>
        {action}
      </div>
      <div className="h4 text-primary">{value}</div>
    </div>
  )
}

export function StatCountValue({ count, quota }: { count: number; quota: number }) {
  return (
    <span>
      {count} <span className="text-tertiary">/ {quota}</span>
    </span>
  )
}
